<div class="info_card__header">
  @if (infoDate) {
    <div class="caption"
      >{{infoDate | date:dateTimeStandard}} {{ "STRINGS.TIME" | translate}}
    </div>
  }
  @if (own) {
    <div class="caption-flag">{{"MEDIFINDER.CARD.OWN" | translate}}</div>
  }
</div>
<div class="info_card__content">
  <div class="info_card__content__text">
    <div class="card-title">{{title}}</div>
    <p class="info_card__content__text__address caption">
      @if (pharmacy$ | async; as pharmacy) {
        {{pharmacy.attributes.name}}<br />
        {{pharmacy.attributes.address}},
        {{pharmacy.attributes.zip}} {{ pharmacy.attributes.city}}
      }
    </p>
  </div>



  <app-svg-icon
    class="icon"
    [src]="'icons/24/arrow-right.svg'"
    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
  ></app-svg-icon>

</div>
